// extracted by mini-css-extract-plugin
module.exports = {"link":"ForexPairs_link__VHB_5"};